import LiveLocationMap from "@pages/LiveLocationMap";
import Unauthorized from "@pages/Unauthorized";
import MainLayout from "components/layout";
import ProtectedRoute from "guards/authGuard";
import { useRoutes } from "react-router-dom";

const Routes = () => {
  const element = useRoutes([
    {
      path: "/unauthorized",
      element: <Unauthorized />,
    },
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <MainLayout />
        </ProtectedRoute>
      ),
      children: [{ path: "/track/share", element: <LiveLocationMap /> }],
    },
  ]);

  return element;
};

export default Routes;
